const values = [
  "unlock_boss_dragon_red",
  "unlock_boss_drowmage_red",
  "unlock_boss_lich",
  "unlock_boss_oldgod",
  "unlock_hero_alchemist",
  "unlock_hero_alchemist_musketeer",
  "unlock_hero_angelwings",
  "unlock_hero_avalanchesurfer",
  "unlock_hero_bearchief",
  "unlock_hero_beemistress",
  "unlock_hero_beetlewarrior",
  "unlock_hero_centaurarcher",
  "unlock_hero_chosengirl",
  "unlock_hero_chosengirl_02",
  "unlock_hero_chosengirl_priestess",
  "unlock_hero_cloudrabbit",
  "unlock_hero_cloudviking",
  "unlock_hero_deathknight",
  "unlock_hero_dryad",
  "unlock_hero_dryad_chef",
  "unlock_hero_evilwings",
  "unlock_hero_flamegoddess",
  "unlock_hero_flamethrower",
  "unlock_hero_foreseer",
  "unlock_hero_hercules",
  "unlock_hero_iceMage",
  "unlock_hero_lastdragoon",
  "unlock_hero_lavachef",
  "unlock_hero_lionking",
  "unlock_hero_merfolk_fighter",
  "unlock_hero_ramhammer",
  "unlock_hero_reaper",
  "unlock_hero_ronin",
  "unlock_hero_sandscorpion",
  "unlock_hero_smith",
  "unlock_hero_toadshaman",
  "unlock_hero_windknight",
  "unlock_hero_wolfhuntress",
  "unlock_hero_yeti",
  "unlock_necromancer_zombiemaster",
  "unlock_tower_arcane",
  "unlock_tower_axemantower",
  "unlock_tower_beetletower",
  "unlock_tower_bigheadtower",
  "unlock_tower_cannon",
  "unlock_tower_catapulttower",
  "unlock_tower_cloudtower",
  "unlock_tower_crusader",
  "unlock_tower_darkportal",
  "unlock_tower_flame_cannon",
  "unlock_tower_frost",
  "unlock_tower_huntershut",
  "unlock_tower_leviathan",
  "unlock_tower_lighthouse",
  "unlock_tower_merman",
  "unlock_tower_mummybarracks",
  "unlock_tower_planttower",
  "unlock_tower_repeater",
  "unlock_tower_scorcher",
  "unlock_tower_stoneguard",
  "unlock_tower_tesla",
  "unlock_unit_arrowtower_unit_rank01",
  "unlock_unit_barracks_troop_rank03",
  "unlock_unit_boarbarian_assassin",
  "unlock_unit_boarbarian_ranger",
  "unlock_unit_drow_mage_red",
  "unlock_unit_druidtower_caster_rank3",
  "unlock_unit_goblin_assassin",
  "unlock_unit_golem_stone",
  "unlock_unit_mermanwarrior",
  "unlock_unit_ooze_green",
  "unlock_unit_skeletonwarrior",
  "unlock_unit_treant",
];
export default values;
